var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInt = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.245 3.583a.75.75 0 0 0-1.49-.166L5.55 5.25H3.5a.75.75 0 0 0 0 1.5h1.884l-.277 2.5H3.5a.75.75 0 0 0 0 1.5h1.44l-.185 1.667a.75.75 0 1 0 1.49.166l.204-1.833h2.49l-.184 1.667a.75.75 0 1 0 1.49.166l.204-1.833H12.5a.75.75 0 0 0 0-1.5h-1.884l.278-2.5H12.5a.75.75 0 0 0 0-1.5h-1.44l.185-1.667a.75.75 0 0 0-1.49-.166L9.55 5.25h-2.49l.184-1.667zM6.894 6.75l-.278 2.5h2.49l.278-2.5h-2.49z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInt);
export default ForwardRef;